import XerOeps from '@/components/errors/XerOeps';
import XerNotFound from '@/components/errors/XerNotFound';
import XerUnauthorized from '@/components/errors/XerUnauthorized';

export default {
  XerOeps,
  XerNotFound,
  XerUnauthorized
};
